export default "__VITE_ASSET__faae3bea__"